import { keyframes } from '@emotion/react';

var fadeIn = keyframes({
    from: { opacity: 0 },
    to: { opacity: 1 },
});
var rotate = keyframes({
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(359deg)" },
});

export { fadeIn, rotate };
//# sourceMappingURL=animations.js.map
